export type BorderRadiusToken = keyof typeof borderRadiusTokens;

export const borderRadiusTokens = {
  "$radius-xsmall": "4px",
  "$radius-small": "8px",
  "$radius-medium": "12px",
  "$radius-large": "16px",
  "$radius-xlarge": "24px",
  "$radius-circle": "100vw",
};
